export const colors = {
  base: '#13120c',
  primary: '#FEE834',
  contrast: '#ffffff',
  muted: '#808080',
  // Layer colors with increasing white mix using hex values
  layer: {
    1: '#1b1a15', // 97% base, 3% white
    2: '#232219', // 94% base, 6% white
    3: '#2b2a22', // 91% base, 9% white
    4: '#33322b', // 88% base, 12% white
    5: '#3b3a33', // 85% base, 15% white
    6: '#43423c', // 82% base, 18% white
    7: '#4b4a44', // 79% base, 21% white
    8: '#53524d', // 76% base, 24% white
    9: '#5b5a55', // 73% base, 27% white
    10: '#63625e', // 70% base, 30% white
  }
};

export const layout = {
  borderRadius: {
    base: '3px',
    large: '9px'
  },
  topbarHeight: '80px'
};

export const spacing = {
  xs: '5px',
  sm: '10px',
  md: '20px',
  lg: '40px'
};

export const typography = {
  size: {
    sm: '12px',
    md: '15px',
    lg: '18px',
    xl: '24px',
    xxl: '32px'
  },
  family: {
    body: "'Funnel Sans', sans-serif",
    heading: "'Funnel Sans', sans-serif"
  }
};

// Combine all theme variables into a single theme object
export const theme = {
  colors,
  layout,
  spacing,
  typography
} as const;

// Default export for easier importing
export default theme; 